import React from 'react';
import { currencyFormatter } from 'shared/utils/currencyFormatter';
import { displayAnnualAmount } from 'Quotes/utils/priceDisplay';

interface FttpAggregationChargeProps {
  fttpAggregationCharge: number;
  viewAsMonthly: boolean;
}

const FttpAggregationCharge: React.FC<FttpAggregationChargeProps> = ({
  fttpAggregationCharge,
  viewAsMonthly,
}) => {
  return (
    <div className="price-summary__segment-wrapper font-italic pl-2">
      <div>Includes: FTTP Aggregation Surcharge {viewAsMonthly ? 'per month' : 'per year'}</div>
      <div className="d-flex flex-column align-items-end flex-fill">
        <b className="total currency">
          {currencyFormatter.format(displayAnnualAmount(fttpAggregationCharge, viewAsMonthly) ?? 0)}
        </b>
      </div>
    </div>
  );
};

export default FttpAggregationCharge;
